import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      style={{
        background: '#1a1a18',
        padding: '32px 24px',
      }}
    >
      <div style={{
        maxWidth: 1100,
        margin: '0 auto',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 16
      }}>

        {/* Left: Brand */}
        <div>
          <div style={{
            fontSize: 18, fontWeight: 700, color: 'white'
          }}>
            Gu<span style={{color:'#1D9E75'}}>Mi</span>
          </div>
          <div style={{
            fontSize: 12,
            color: 'rgba(255,255,255,0.4)',
            marginTop: 4
          }}>
            Know before you apply.
          </div>
        </div>

        {/* Center: Links */}
        <div style={{
          display: 'flex',
          gap: 24,
          alignItems: 'center'
        }}>
          <Link to="/privacy" style={{
            fontSize: 12,
            color: 'rgba(255,255,255,0.5)',
            textDecoration: 'none'
          }}>Privacy</Link>
          <Link to="/terms" style={{
            fontSize: 12,
            color: 'rgba(255,255,255,0.5)',
            textDecoration: 'none'
          }}>Terms</Link>
        </div>

        {/* Right: Copyright */}
        <div style={{
          fontSize: 12,
          color: 'rgba(255,255,255,0.4)'
        }}>
          © 2026 GuMi · Built in India
        </div>

      </div>
    </footer>
  );
};

export default Footer;
